import { useEffect, useState } from 'react'
import errorImage from '../../../_metronic/images/error.png';
import { useNavigate } from 'react-router-dom';
import { useLazyQuery } from '@apollo/client';
import { GETUSERPROFILE } from '../../../utils/GraphQLAPI';

export const Page404 = () => {
  const navigate = useNavigate();
  const [url, setUrl] = useState<string>('');
  const accessToken = localStorage.getItem('_accesstoken');
  const [getUserData] = useLazyQuery(GETUSERPROFILE, {
    fetchPolicy:'network-only',
    onCompleted: async(data) => {
    data.getUserProfile.userRole === 'TPV_ADMIN' && setUrl('/tpvadmin/tpv-dashboard') ;
    data.getUserProfile.userRole === 'USER' && data.getUserProfile.members?.map((user:{role:string}) => {
      switch(user.role){
        case 'AGENT':
          setUrl('/agent/agent-dashboard')
          break;
        case 'SYSTEM_ADMIN':
          setUrl('/systemadmin/dashboard')
          break;
        case 'SALES_ADMIN':
          setUrl('/salesadmin/sales-dashboard')
          break;
        case 'QC_USER':
          setUrl('/qcuser/qc-dashboard')
          break;
      }
    }) 
  }})
    useEffect(()=>{
      accessToken ? getUserData() : setUrl('/tpvadmin/login');
    },[])
  return (
    <div className='d-flex justify-content-center vh-100 align-items-center'
    style={{backgroundImage: 'linear-gradient(#4251a6, #7c87c8)'}}>
      <div className='box-sizing gap-3 d-flex flex-column align-items-center justify-content-center bg-white rounded-3' 
        style={{padding: '5vw 3vw',width:'33vw',minWidth:'250px', minHeight:'300px'}}>
        <h1 className="text-black fw-bolde text-center">Oops!</h1>
        <p className='text-gray-500 fw-semibold fs-6 text-center'>It seems something went wrong</p>
        <img className='img-fluid' src={errorImage} width='70%'/>
        <button className='btn btn-primary btn-sm mt-5' onClick={()=>navigate(url)}>{`Back to ${accessToken ? 'dashboard' : 'login'}`}</button>
      </div>
    </div>
  )
}
